import { schema } from "normalizr";

export const studySchema = new schema.Entity("studies");
